import { useCallback, useMemo } from "react"
import { useNavigate } from "react-router-dom"

import { Box, useTheme } from "@mui/material"

import { useTranslation } from "providers/i18n"
import { useFeatureDetail } from "hooks/feature/useFeatureDetail"

import { PageCard } from "components/card"
import { NavigationControl } from "components/kioskHorizontal/navigation"

import { FeatureDetailKioskH } from "extensions/em-core/components/FeatureDetailKioskH"

export const PlaceDetailPage = ({ Layout = Box }) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const theme = useTheme()

  const sideBarStyleOverrides =
    theme.components[`AppSidebar`]?.styleOverrides || {}

  const { wrapper, footer, body } = sideBarStyleOverrides

  const { dataLoaded, ...data } = useFeatureDetail()
  const {
    logo,
    category,
    level,
    name,
    hours,
    id,
    coverImage,
    venueLogo,
    description,
    promotions = [],
    placeDetailMobileUrl,
    relatedOccupants,
    categoryIconPath: categoryIcon,
  } = data

  const levelName = useMemo(
    () => (level ? `${t(level)} ${t("Floor")}` : "-"),
    [t, level]
  )

  const isShowPromotionButton = promotions && promotions.length > 0

  const onNavigate = useCallback(() => {
    navigate(`/maps/dir/unknown/${id}`, {
      state: {
        prevDestinationId: id,
      },
    })
  }, [navigate, id])

  return (
    <Layout
      aside={
        <PageCard>
          <Box sx={wrapper}>
            <Box sx={body}>
              <FeatureDetailKioskH
                id={id}
                name={name}
                list={relatedOccupants}
                description={description}
                coverImage={coverImage}
                category={category}
                categoryIcon={categoryIcon}
                placeDetailMobileUrl={placeDetailMobileUrl}
                isShowPromotionButton={isShowPromotionButton}
                logo={logo}
                venueLogo={venueLogo}
                levelName={levelName}
                hours={hours}
                onNavigate={onNavigate}
              />
            </Box>
            <Box sx={footer}>
              <NavigationControl />
            </Box>
          </Box>
        </PageCard>
      }
    />
  )
}
